import { attempt, set, get, has, isPlainObject } from 'lodash'

class LocalStorageWrapper {
    constructor(prefix = 'localStorageWrapper') {
        this._prefix = prefix
    }
    get(path, defaultValue = undefined) {
        const data = attempt(JSON.parse, window.localStorage.getItem(this._prefix))
        if (isPlainObject(data)) {
            return get(data, path, defaultValue)
        } else {
            return defaultValue
        }
    }

    set(path, value) {
        let data = attempt(JSON.parse, window.localStorage.getItem(this._prefix))
        if (!isPlainObject(data)) {
            data = {}
        }
        set(data, path, value)
        const plainData = attempt(JSON.stringify, data)
        window.localStorage.setItem(this._prefix, plainData)
    }

    has(path) {
        const data = attempt(JSON.parse, window.localStorage.getItem(this._prefix))
        if (isPlainObject(data)) {
            return has(data, path)
        }
        return false
    }
}

export default new LocalStorageWrapper('asd')
